module.exports = __webpack_public_path__ + "img/了解更多-二维码-1.f0de46a3.jpg";